export default "__VITE_ASSET__BPenibVZ__"